<template>
	<div class="event-split2-popup">
		<b-row class="banner">
			<transition mode="out-in">
				<div class="scroll-banner" v-show="scrolled > 76">
					<h2 class="title">{{ EventData.title }}</h2>
					<div class="link">
						<img
							@click="closeSlide"
							class="close"
							src="@/assets/about/corner/btn_back.svg"
							alt=""
						/>
						<a target="_blank" :href="EventData.link">前往報名</a>
					</div>
				</div>
			</transition>
			<img
				@click="closeSlide"
				class="close2"
				src="@/assets/about/corner/btn_back.svg"
				alt=""
			/>
			<div class="row-grid" style="width:100%;">
				<div class="left-banner">
					<carousel
						:options="{ interval: 4000, duration: 1000, loop: true }"
						indicator="inside"
						control
						:key="EventData.pictures && EventData.pictures.length"
					>
						<template v-for="(pic, index) in EventData.pictures">
							<img :src="pic.url" width="100%" :key="index" />
						</template>
					</carousel>
				</div>
				<div class="scrollable">
					<div class="wrapper">
						<h1 class="title">{{ EventData.title }}</h1>
						<h2 class="date">
							演出日期：
							<span v-for="(period, i) in EventData.periods" :key="i">
								<br />&nbsp;&nbsp;
								<span v-if="period[0] == period[1]">{{
									new Date(period[0]).toLocaleDateString()
								}}</span>
								<span v-else
									>{{ new Date(period[0]).toLocaleDateString() }} ~
									{{ new Date(period[1]).toLocaleDateString() }}</span
								>
							</span>
						</h2>
						<br />
						<h2 class="author">藝術家：{{ EventData.author }}</h2>
						<br />
						<h2 class="brief">{{ EventData.brief }}</h2>
						<br />
						<div class="link row" align-x="right" style="margin-bottom:30px;">
							<a target="_blank" :href="EventData.link">前往報名</a>
						</div>
					</div>
				</div>
			</div>
		</b-row>
		<div class="share-box" v-show="EventData.shareLink">
			<a
				target="_blank"
				class="fb"
				:href="
					`https://www.facebook.com/sharer/sharer.php?u=${EventData.shareLink}`
				"
			>
				<img src="/static/assets/share/fb.svg" alt="" />
			</a>
			<a
				target="_blank"
				class="line"
				:href="`http://line.me/R/msg/text/?lize%0D%0A${EventData.shareLink}`"
			>
				<img src="/static/assets/share/line.svg" alt="" />
			</a>
			<a
				target="_blank"
				class="twitter"
				:href="`https://twitter.com/home?status=${EventData.shareLink}`"
			>
				<img src="/static/assets/share/twitter.svg" alt="" />
			</a>
		</div>
		<div class="content" v-html="EventData['content']"></div>
	</div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
	data() {
		return {
			scrolled: 0,
			EventData: {},
			_path: ""
		};
	},
	methods: {
		...mapActions(["getEventContent"]),
		onSlideStart(slide) {
			this.sliding = true;
		},
		onSlideEnd(slide) {
			this.sliding = false;
		},
		closeSlide() {
			this.$router.push("/event/list");
		},
		timeConvert(timeStamp) {
			let date = new Date(timeStamp);
			let m = date.getMonth() + 1;
			let d = date.getDay();
			return m + "/" + d + " ";
		},
		handleScroll() {
			this.scrolled = window.scrollY;
		}
	},
	mounted() {
		this.getEventContent(this.$route.params.id).then(() => {
			this.EventData = this.$store.state.event;
		});
		this._path = window.location.href;
		setInterval(function() {
			$("iframe").attr("width", "100%");
			$("iframe").attr("height", "500px");
		}, 500);
	},
	components: {
		Carousel: () => import("./Carousel")
	},
	created() {
		window.addEventListener("scroll", this.handleScroll);
	},
	destroyed() {
		window.removeEventListener("scroll", this.handleScroll);
	}
};
</script>

<style lang="scss" scoped>
.scrollable {
	.link {
		width: 100%;
	}
}
.content {
	max-width: 1200px;
	margin: 0 auto 60px;
}
.row-grid {
	.left-banner {
		width: 100%;
		@media screen and (min-width: 768px) {
			width: 50%;
		}
		position: relative;

		&::before {
			content: "";
			display: block;
			padding-top: 60%;
		}

		.carousel {
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
		}
	}
	.scrollable {
		flex: 1;
		background: #222222;
		color: #fff;
		line-height: 2;

		.wrapper {
			padding: 30px;
		}

		.title {
			font-size: 1.3em;
			margin: 20px 0;
		}

		@media screen and (min-width: 768px) {
			position: relative;
			overflow-y: auto;

			&::before {
				content: "";
				display: block;
				padding-top: 60%;
			}

			.wrapper {
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				bottom: 0;
			}
		}
	}
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
@import '../stylesheet/base.sass'
@import '../stylesheet/layout.sass'

.event-split2-popup
  overflow: hidden
  position: relative
  width: 100%
  top: 0px
  left: 0
  .scroll-banner
    +flexLayout('between', 'row')
    position: fixed
    top: 90px
    left: 0
    width: 100%
    z-index: 100
    background-color: #222222
    color: white
    padding: 20px 130px
    flex-wrap: wrap
    height: 75px
    .link
      a
        font-size: 20px
        padding: 5px 10px
        margin-right: 10px
    @media screen and (max-width: 990px)
      height: 100px
      padding: 0
      +flexLayout('center', 'col')
      top: 91px

      .link
        margin-top: 12px
        a
          font-size: 16px
          padding: 5px 10px
          margin: 0
      .close
        position: absolute
        top: 23px
        right: 26px
    .title
      font-size: 24px !important
    .close
      +size(30px, 30px)
      z-index: 500
      opacity: 1
      @media screen and (max-width: 990px)
        top: 23px
        right: 26px
  .link a
    color: white
    padding: 18px 50px
    border-radius: 100px
    font-size: 24px
    background-color: #01b6e2
    @media screen and (max-width: 990px)
      margin-top: 15px
      padding: 5px 10px
      font-size: 18px
  .banner
    .banner-item
      word-wrap: break-word
      height: 480px
      line-height: 1.5
      letter-spacing: 2px
      .brief
        margin-bottom: 30px
      #carousel1
        .carousel-inner
          width: 100%
          height: 480px
        .carousel-item
          background-size: cover
          background-position: 50% 50%
          height: 480px
          width: 100%
      @media screen and (max-width: 990px)
        min-height: 300px
        height: initial
        #carousel1
          .carousel-inner
            width: 100%
            height: 300px
          .carousel-item
            background-size: cover
            background-position: 50% 50%
            height: 300px
            width: 100%

    .left
      background-color: white
      padding: 0
    .right
      background-color: $themeGray
      color: $white
      padding: 45px
      overflow-y: auto
      font-weight: 300
      .title
        font-size: $font-size-3
        margin: 20px 0
      .content
        font-size: $font-size-3-s
        line-height: 1.5
        letter-spacing: 3px
    .close2
      +size(30px, 30px)
      position: absolute
      right: 26px
      top: 45px
      z-index: 50
      opacity: 1
      transform: translateY(-50%)
  .content
    background-color: white
    padding: 50px 130px
    font-size: $font-size-3
    line-height: 1.5
    min-height: 1000px
  @media all and (max-width: 800px)
    .content
      padding: 50px 30px
  .share-box
    width: 100%
    padding: 0 40px
    line-height: 1.3
    letter-spacing: 2px
    max-width: 1000px
    margin: 30px auto

    img
      width: 30px
      height: 30px
      margin-right: 10px
</style>



// WEBPACK FOOTER //
// src/components/event_split2_content.vue